import { IClientTest, IAssessmentTest } from "@/modules/assessments/types/test.interface";

export function getTestDisplayName(test: { name?: string; internalName?: string }): string {
  if (!test.name) return "";
  return test.internalName ? `${test.name} (${test.internalName})` : test.name;
}

export class TestsUtils {
  static getAssessmentTestsStats(tests: IClientTest[], assessmentTests?: IAssessmentTest[]) {
    const defaultStats = { timingMs: 0, questions: 0 };

    if (!assessmentTests) {
      return defaultStats;
    }

    return assessmentTests.reduce((acc, assessmentTest) => {
      const test = tests.find(({ testId }) => testId === assessmentTest.testId);

      if (!test || !test.config.suggestedTime) {
        return acc;
      }

      return {
        timingMs: acc.timingMs + test.config.suggestedTime,
        questions: acc.questions + (test.config.questionCount ?? 0),
      };
    }, defaultStats);
  }
}
